import React from 'react';
import { motion } from 'framer-motion';
import { RadioGroup, RadioGroupItem } from '../components/ui/radio-group';
import { Label } from '../components/ui/label';

const QuestionCard = ({ question, questionIndex, totalQuestions, selectedValue, onAnswer }) => {
  // Use question-specific options if available, otherwise fallback
  const options = question.options || [];

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
      className="bg-white border border-[#E2E8E8] rounded-lg p-6 md:p-8 shadow-sm"
      data-testid={`question-card-${question.id}`}
    >
      {/* Question number */}
      <div className="flex items-center justify-between mb-4">
        <span className="text-sm font-medium text-[#787A7A] uppercase tracking-wider">
          Question {questionIndex + 1} of {totalQuestions}
        </span>
        <span className="text-xs text-[#787A7A] bg-[#F5F7F7] px-3 py-1 rounded-full">
          {question.id.toUpperCase()}
        </span>
      </div>
      
      {/* Question text */}
      <h3 className="text-xl md:text-2xl font-serif font-semibold text-[#0A0A0A] mb-2">
        {question.text}
      </h3>
      
      {/* Question description */}
      {question.description && (
        <p className="text-[#787A7A] text-sm mb-6">
          {question.description}
        </p>
      )}
      
      {/* Answer options - A/B/C/D format */}
      <RadioGroup
        value={selectedValue !== undefined ? selectedValue.toString() : ""}
        onValueChange={(value) => onAnswer(question.id, parseInt(value))}
        className="space-y-3"
        data-testid={`question-options-${question.id}`}
      >
        {options.map((option) => (
          <div
            key={option.value}
            className={`flex items-center space-x-3 p-4 rounded-lg border-2 transition-all duration-200 cursor-pointer hover:border-[#005858] hover:bg-[#F5F7F7] ${
              selectedValue === option.value
                ? 'border-[#005858] bg-[rgba(0,88,88,0.05)]'
                : 'border-[#E2E8E8]'
            }`}
            onClick={() => onAnswer(question.id, option.value)}
          >
            <RadioGroupItem
              value={option.value.toString()}
              id={`${question.id}-${option.value}`}
              className="border-[#005858] text-[#005858]"
              data-testid={`option-${question.id}-${option.value}`}
            />
            <Label
              htmlFor={`${question.id}-${option.value}`}
              className="flex-1 cursor-pointer text-base font-medium text-[#0A0A0A]"
            >
              <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#F5F7F7] text-[#005858] font-bold text-sm mr-3">
                {option.label}
              </span>
              {option.text}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </motion.div>
  );
};

export default QuestionCard;
